function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BDEDF8;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#66CEEF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M334.28,467.35c15.4-19,36.4-37.8,65.2-58c28.6-21.4,58.6-40.2,77.2-47.8c0.4-0.2,0.6-0.2,1-0.4 c1.4-0.6,2.8-1.2,4-1.6c0.2,0,0.6,0,0.8,0c17.8-5.6,25.4,3,31.4,12.8c1,1.8,2,3.4,2.8,4.4l4,2.2c0.2,0,0.6,0,0.8,0 c1.8-0.6,5.4-2,12-5.4l108.2-63c1.2-0.8,2-1.6,3-2.2c5-3.6,8.8-7.4,11.4-11.6c0,0,0-0.2,0.2-0.2c1.4-2.4,2.8-5,3.8-7.6 c1.2-2.8,2.2-5.8,3.4-8.8c2-5.6,4.2-11.6,7.4-17.6c0.2-0.2,0.2-0.4,0.4-0.8c0.8-1.4,1.6-2.8,2.4-4c0.6-0.8,1-1.6,1.6-2.4 c0.8-1.2,1.6-2.2,2.6-3.4c0.8-1,1.6-2,2.4-3c0.8-1,2-2.2,3-3.2c1-1,2-2.2,3.2-3.2c1-1,2.4-2,3.6-3c1.2-1.2,2.6-2.2,4-3.2 c1.4-1,2.8-2,4.2-3c1-0.6,1.6-1.2,2.6-1.8c29.8-19.2,65.6-39.4,97.8-49.2c10-3.6,18.8-5.6,26.4-6.6l-45.6-26.4c0,0,0,0,0,0.2 c-0.2,1.8-1.4,3.6-3,4.4l-129,74.2c-0.2,0-0.2,0-0.4,0l-0.2,0.2c-0.8,0.4-1.8,0.6-2.6,0.6c-1,0-2.2-0.4-3.2-1l-62.8-38.6 c-2-1.2-3.4-3.6-3-6c2.8-20.4,12.6-35.4,30.4-45.8c28-16.4,67.2-37.8,90.2-35.2c-20.8-6.2-47.4,5.4-65.4,13.6 c-92.8,41.6-99,61.6-104.8,80.6c-2.6,8.4-5.2,17-13.8,27c-11.8,13.8-123.6,75.4-129.2,78.4l36.6,19c1,0.2,2,0.4,3,0.8 c4.4,2,7.4,5.8,8.4,10.8l2.4,12c0.6,2.6-0.6,5.2-3,6.6l-127.2,73.4c-0.2,0-0.2,0-0.4,0.2c-0.4,0.2-0.6,0.6-1,0.8 c-0.6,0.2-1.2,0.2-1.8,0.2c-1,0-2-0.2-3-0.6l-64-33.2c-3-1.6-4.2-5.4-2.6-8.4c10-19.2,20.4-32.2,38.8-47.4 c15.2-12.6,48.8-35,66.8-44.4c4.8-2.6,11-5,17.2-4.2c-4.6-3-8-4.2-11.4-4.2c-4,0-8.2,1.6-14.8,5.2 c-37.6,19.6-97.6,55.8-134.8,103.2l138.8,80.2C331.88,470.35,333.08,468.95,334.28,467.35z M501.68,265.15 c20.8,0,36.8,10.4,36.8,23.8c0,13.4-16.2,23.8-36.8,23.8s-36.6-10.6-36.6-23.8C465.08,275.55,481.28,265.15,501.68,265.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M121.68,833.75c-0.2-0.2-0.6-0.4-0.8-0.8C121.08,833.35,121.28,833.55,121.68,833.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M102.68,781.35c0-14,2.2-28.6,4.8-43C104.68,752.75,102.48,767.35,102.68,781.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M156.28,427.55c2.6-6.2,5.6-12.2,9-18.4C161.88,415.15,158.68,421.35,156.28,427.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M185.88,387.95l0.8,0.4c35.4-45.2,92-82,137.4-105.6c23-12,25.8-4,55.6,13c5.6-2.6,117.2-64.8,127.6-77.2 c27.2-32-11.8-49.8,120.6-109.2c22.4-10,53.8-23.6,77.4-11l130.8,75.4c7.6,0.2,14.2,1.6,19.8,4.4c1.4,0.6,2.4,1.8,3.6,2.6 c-0.4-0.2-0.4-0.8-0.8-1l-150.6-86.8c-27-14.2-61.8,1.4-82.8,10.8c-97.8,44-104.8,66.6-111.6,88.2c-2.4,7.8-4.6,14.6-11.4,22.6 c-8.4,9.8-103,63.8-122.8,74c-4.4-2.6-8-4.8-11.4-7c-17.4-11-25.4-16-47.2-4.6c-44.6,23.2-120,69.4-155,130.6 c3.6-6.2,7.6-12.2,12-18.4C179.68,387.15,183.08,386.55,185.88,387.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.08,232.55c2.4-1.6,4.6-3.2,7.4-4.8c39.8-23.2,69.6-38.2,93-46.4c-32,10-68,30-97.8,49.2 C699.68,231.35,698.88,231.95,698.08,232.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M682.88,245.35c1-1,2-2.2,3.2-3.2C684.88,243.15,683.88,244.35,682.88,245.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M644.68,308.35c5-3.4,8.8-7.2,11.4-11.6C653.48,300.95,649.68,304.75,644.68,308.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M680.08,248.55c-0.8,1-1.6,2-2.4,3C678.28,250.55,679.08,249.55,680.08,248.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.08,261.55c-0.2,0.2-0.2,0.4-0.4,0.8C670.88,262.15,671.08,261.75,671.08,261.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.08,288.75c-1.2,2.6-2.4,5.2-3.8,7.6C657.68,294.15,658.88,291.55,660.08,288.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.68,375.75l3.8-2.2c-6.6,3.4-10.2,4.8-12,5.4C523.48,378.75,525.88,377.95,529.68,375.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M326.68,288.35c6.6-3.4,10.8-5.2,14.8-5.2c3.4,0,6.8,1.4,11.2,3.8c1.6,0.2,3.2,0.6,4.8,1.2l25,13 c5.6-3,117.4-64.6,129.2-78.4c8.6-10,11.2-18.6,13.8-27c6-19.2,12-39,104.8-80.6c18-8.2,44.6-19.8,65.4-13.6c0.4,0,1,0,1.4,0 l9.8,3.4l62.8,32.6c0.2,0,0.2,0.2,0.4,0.2l1.4,0.8c0.4,0.2,0.4,0.6,0.8,0.8c1.8,1.2,3.8,2.4,5.4,4c1.2,1.4,1.8,3.2,1.6,5l45.6,26.4 c3.8-0.6,7.6-0.8,11-0.8l-130.8-75.4c-23.6-12.6-55,1-77.4,11c-132.4,59.4-93.6,77.2-120.6,109.2c-10.4,12.2-122,74.6-127.6,77.2 c-29.8-17.2-32.6-25.2-55.6-13c-45.4,23.6-102,60.4-137.4,105.6l5.4,3C229.08,344.15,289.08,307.95,326.68,288.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.08,255.15c-0.6,0.8-1,1.6-1.6,2.4C674.08,256.75,674.48,255.95,675.08,255.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.68,378.95l-4-2.2C517.88,378.15,519.08,378.75,520.68,378.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.88,359.75c-1.2,0.4-2.6,1-4,1.6c1.8-0.8,3.2-1.2,4.8-1.6C482.28,359.75,482.08,359.55,481.88,359.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M330.88,471.75L330.88,471.75c1.2-1.4,2.4-2.8,3.6-4.2C333.08,468.95,331.88,470.35,330.88,471.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.68,361.75c-18.6,7.6-48.6,26.4-77.2,47.8c19-13.4,40.8-27.2,67.2-42.6 C470.28,364.75,473.68,362.95,476.68,361.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M693.68,235.75c-1.4,1-2.8,2.2-4,3.2C690.88,237.95,692.28,236.75,693.68,235.75z"
}), React.createElement("path", {
  className: "st2",
  d: "M501.68,300.55c14,0,24.6-6,24.6-11.6c0-5.4-10.4-11.6-24.6-11.6c-13.8,0-24.6,6.2-24.6,11.6 C477.28,294.35,487.88,300.55,501.68,300.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M501.68,312.95c20.8,0,36.8-10.6,36.8-23.8c0-13.4-16.2-23.8-36.8-23.8s-36.6,10.4-36.6,23.8 C465.08,302.35,481.28,312.95,501.68,312.95z M501.68,271.35c17,0,30.8,8,30.8,17.6c0,9.8-13.8,17.8-30.8,17.8 c-16.8,0-30.6-8-30.6-17.8C471.08,279.15,484.88,271.35,501.68,271.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M501.68,306.75c17,0,30.8-8,30.8-17.8c0-9.8-13.8-17.6-30.8-17.6c-16.8,0-30.6,8-30.6,17.6 C471.08,298.75,484.88,306.75,501.68,306.75z M501.68,277.55c14,0,24.6,6.2,24.6,11.6c0,5.4-10.4,11.6-24.6,11.6 c-13.8,0-24.6-6-24.6-11.6C477.28,283.55,487.88,277.55,501.68,277.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.48,291.15c-18,9.2-51.6,31.6-66.8,44.4c-18.2,15.2-28.6,28-38.8,47.4c-1.6,3-0.4,6.8,2.6,8.4l64,33.2 c0.8,0.4,2,0.6,3,0.6c0.6,0,1.2,0,1.8-0.2c0.4-0.2,0.6-0.6,1-0.8c-0.8,0.4-1.6,0.6-2.6,0.6c-1.6,0-3.2-0.6-4.2-1.6 c-2-1.8-2.6-4.6-1.4-7l-58.6-30.6c10.2-19.4,20.2-31.2,37.2-45.4c15-12.8,48.4-34.8,65.4-43.8c4.8-2.4,11.4-5.2,16.6-2.8l52.6,27.4 c4.4-1.4,8.4-1.6,11.8-1l-36.6-19c-0.2,0-0.4,0.2-0.4,0.2c-1.8,0.8-4,0.8-5.6-0.2c-5.8-3.4-10.4-6.2-14.6-9c-3.6-2.2-6.4-4-9-5.4 C346.48,286.15,340.28,288.55,335.48,291.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.28,301.35c1.8,1,3.8,1,5.6,0.2l0.4-0.2l-25-13c-1.6-0.8-3.2-1-4.8-1.2c2.6,1.4,5.4,3.2,9,5.4 C365.88,295.15,370.48,297.95,376.28,301.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M299.08,406.75c-0.6,1-1.2,1.8-1.8,2.8l-0.6,1.4l-53-27.6c8.6-15,17.6-25.4,32.8-38.2 c14.4-12,47.6-34.2,64.4-43c2.2-1,8-4.2,11-2.8l47.8,24.8c-1.4,0.8-2.6,1.4-3.6,2c4.2-2.4,7.8-4,11.2-5l-52.6-27.4 c-5.2-2.6-11.8,0.4-16.6,2.8c-17,8.8-50.4,31-65.4,43.8c-17,14.2-27.2,26-37.2,45.4l58.6,30.6v-0.2 C295.48,412.95,297.28,409.75,299.08,406.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M306.28,396.15c-0.6,0.8-1,1.6-1.6,2.2C305.08,397.75,305.68,396.95,306.28,396.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M396.08,326.15c-15.6,9-32.4,19.4-48.4,31C360.88,347.55,376.68,337.55,396.08,326.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M424.28,329.75c-0.2,0.4-0.6,0.6-1,0.8c0.4,0.8,0.8,1.6,1,2.6l2.4,12l-116.6,67.4c-0.6,0.8-1.2,1.8-1.8,2.6 l-3.6,6.6c-0.6,1-1.6,1.6-2.6,2.2c0.2,0,0.2,0,0.4-0.2l127.2-73.4c2.2-1.4,3.4-4,3-6.6l-2.4-12c-1-5-4-9-8.4-10.8 c-1-0.4-2-0.6-3-0.8l2.6,1.4C424.48,323.15,425.68,326.75,424.28,329.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.68,398.55c-2,2.8-3.8,5.4-5.4,8.2C300.88,403.95,302.68,401.15,304.68,398.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M306.28,396.15c11-14.4,25.8-27.2,41.4-39C329.28,370.75,315.88,383.15,306.28,396.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M342.48,368.95c14.6-11.6,33-23.6,56.8-37.4C381.48,341.75,360.88,354.35,342.48,368.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M399.28,331.55c4-2.4,7.4-3.8,10.2-4.6C405.88,327.95,402.28,329.75,399.28,331.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M308.28,415.35c0.6-0.8,1.2-1.8,1.8-2.6l-10.4,6c1.4-3,3-5.8,4.8-8.6c-0.4,0.8-1,1.4-1.4,2.2l-3.6,6.8 l-5.4-2.8c-1.2,2.4-0.6,5.2,1.4,7c1,1,2.6,1.6,4.2,1.6c1,0,1.8-0.2,2.6-0.6c1-0.6,2.2-1.2,2.6-2.2L308.28,415.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M310.08,401.55c0.6-0.8,1-1.6,1.6-2.4C311.08,399.95,310.48,400.75,310.08,401.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M407.28,321.15l9.2,4.8c3.4,0.4,5.6,2.2,6.8,4.6c0.2-0.4,0.8-0.4,1-0.8c1.4-3,0.2-6.6-2.6-8l-2.6-1.4 C415.68,319.55,411.68,319.75,407.28,321.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M302.88,412.35c0.4-0.8,1-1.4,1.4-2.2c1.8-2.8,3.6-5.8,5.6-8.6c0.6-0.8,1-1.6,1.6-2.4 c7.6-10.2,17.8-20,30.8-30.2c18.4-14.6,39-27.2,56.8-37.4c3-1.8,6.6-3.6,10.2-4.6c2.8-0.8,5.2-1,7.2-0.8l-9.2-4.8 c-3.4,1-7.2,2.6-11.2,5c-19.4,11.2-35,21.4-48.4,31c-15.8,11.6-30.4,24.6-41.4,39c-0.6,0.8-1,1.6-1.6,2.2c-2,2.8-3.8,5.4-5.4,8.2 c-1.8,3-3.6,6.2-5,9.4v0.2l5.4,2.8L302.88,412.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M403.88,336.15c1-0.6,2.2-1.2,3-1.6C405.88,334.95,404.88,335.55,403.88,336.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M417.48,332.75c0.2,0.2,0.4,0.8,0.6,1.6l1.8,7.8l-101.2,58.4c-3.2,4-6,8-8.6,12l116.6-67.4l-2.4-12 c-0.2-1-0.6-1.8-1-2.6C421.88,332.35,419.88,333.15,417.48,332.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M407.08,334.35c1.2-0.6,2.4-1,3.4-1.4C409.48,333.35,408.28,333.75,407.08,334.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M348.88,371.75c0.2-0.2,0.4-0.4,0.6-0.4C349.28,371.35,349.08,371.55,348.88,371.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M355.08,367.15c11.8-8.6,26-17.8,43.2-27.8C384.28,347.55,369.28,356.75,355.08,367.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M409.48,326.95c-3,0.8-6.2,2.4-10.2,4.6c-23.8,13.8-42,25.8-56.8,37.4c-11.6,9.2-22.4,19.4-30.8,30.2 c-0.6,0.8-1.2,1.6-1.6,2.4c-2,2.8-4,5.6-5.6,8.6c-1.6,2.8-3.4,5.6-4.8,8.6l10.4-6c2.4-4.2,5.4-8.2,8.6-12l-0.6,0.4 c7.6-9.6,17.6-19.2,30.8-29.2c0.2-0.2,0.4-0.4,0.6-0.4c1.8-1.4,3.8-2.8,5.6-4.2c14-10.4,29-19.6,43.2-27.8c1.4-0.8,2.6-1.6,4-2.4 c0.6-0.4,1-0.6,1.6-0.8c1-0.6,2-1.2,3-1.6h0.2c1.2-0.6,2.4-1,3.4-1.4c2.2-0.8,3.6-1,4.6-1c1,0,1.6,0.2,1.8,0.2s0.4,0.2,0.6,0.6 c2.4,0.4,4.4-0.4,5.8-2.2c-1.2-2.4-3.4-4.2-6.8-4.6l2,1C415.68,325.95,412.48,326.15,409.48,326.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.28,410.15c1.8-3,3.6-5.8,5.6-8.6C307.88,404.35,306.08,407.35,304.28,410.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M342.48,368.95c-13,10.2-23.2,20.2-30.8,30.2C320.08,388.35,330.88,378.35,342.48,368.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M409.48,326.95c3-0.8,6.2-1,9.2,0.2l-2-1C414.68,325.75,412.28,326.15,409.48,326.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.48,136.75c-17.8,10.4-27.6,25.6-30.4,45.8c-0.4,2.4,0.8,4.8,3,6l62.8,38.6c1,0.6,2.2,1,3.2,1 c-1.2,0-2.4-0.4-3.4-1c-2-1.4-3-3.6-2.6-6l0.4-2.6l-57.2-35.2c2.4-18.8,11.4-31.8,27.4-41.4c18.8-11.2,65-38,87.6-34.4l8.6,3.2 l46.4,24.2c1.6-0.2,3,0,4.4,0l-53.6-31c-2-1-4.2-1.8-6.4-2.4C672.88,99.15,633.48,120.35,605.48,136.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.68,227.55l0.2-0.2c-1,0.4-1.8,0.8-2.8,0.8C645.08,228.15,645.88,227.95,646.68,227.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M755.68,134.95c5.2,0,10,0.8,14,2.8l-62.8-32.6l-9.8-3.4c-0.4,0-1,0-1.4,0c2.2,0.6,4.4,1.2,6.4,2.4 L755.68,134.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.48,138.55l-1.4-0.8c0.8,0.4,1.4,1.2,2.2,1.6C772.08,139.15,771.88,138.75,771.48,138.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M727.28,140.95c-0.2,0-0.4,0.2-0.6,0.2C726.88,141.15,727.08,140.95,727.28,140.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.48,148.15c-0.2,0-0.2,0.2-0.4,0.2C710.28,148.15,710.28,148.15,710.48,148.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M695.28,155.75c-1.8,1-3.6,1.8-5.6,3C691.68,157.55,693.28,156.75,695.28,155.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.08,180.35c2.8-14.6,10.2-25,23.8-33c41.6-24.4,69.6-35.8,82.4-33.8l7.8,2.8l39,20.4 c-0.4,0.2-1,0.4-1.4,0.4c4.2-1,8-1.8,11.6-2l-46.4-24.2l-8.6-3.2c-22.6-3.6-68.8,23.2-87.6,34.4c-16.2,9.4-25,22.6-27.4,41.2 l57.2,35l1-6.6L588.08,180.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.28,146.75c-0.8,2-2.8,2.8-4.8,3l-118.4,68c-0.4,1.6-0.6,3.2-1,5c-0.4,2-1.6,3.6-3.2,4.4 c0.2,0,0.2,0,0.4,0l129-74.2c1.6-0.8,2.8-2.6,3-4.4c0,0,0,0,0-0.2l-5-2.8C774.08,145.95,774.28,146.35,774.28,146.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.28,145.55l5,2.8c0.2-1.8-0.4-3.6-1.6-5c-1.6-1.6-3.6-2.8-5.4-4 C774.08,140.95,774.88,143.35,774.28,145.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M769.68,137.55l0.4,0.2C769.88,137.75,769.88,137.75,769.68,137.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.08,148.35c-4.8,2.2-9.6,4.8-14.8,7.4C700.48,153.15,705.48,150.35,710.08,148.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M726.68,141.15c-5,2-10.4,4.2-16.2,7C716.28,145.35,721.68,143.15,726.68,141.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M689.68,158.75c-6.4,3.4-13,7.2-20.2,11.4C676.68,165.95,683.28,162.15,689.68,158.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M639.68,210.15l-0.2,1.6l0.4,0.2c4-18.2,11.2-31,29.8-42C646.08,183.75,641.28,198.75,639.68,210.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M739.68,136.95c-3.8,1-8,2.4-12.4,4C731.68,139.35,735.68,137.95,739.68,136.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M733.88,145.15c0.6-0.2,1.4-0.4,2-0.8C735.28,144.55,734.68,144.95,733.88,145.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M743.88,142.35c1.2-0.2,2.6-0.6,3.6-0.8C746.48,141.75,745.28,141.95,743.88,142.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.08,141.35c1.4,0.2,2.8,0.8,4.2,1.4C763.88,142.15,762.48,141.55,761.08,141.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M755.08,140.75c-0.6,0-1.4,0.2-2,0.2c1.6,0,3,0,4.6,0C756.68,140.95,756.08,140.75,755.08,140.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M650.28,222.95c0.2-1.8,0.6-3.4,1-5l-4,2.4l-3,1.8l-5.6-3.4l-0.4,2.6c-0.4,2.4,0.6,4.6,2.6,6 c1,0.6,2.2,1,3.4,1c1,0,1.8-0.4,2.8-0.8C648.48,226.55,649.88,224.95,650.28,222.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M712.08,154.15c4.4-2,8.2-3.8,12.2-5.4C720.08,150.35,716.08,152.15,712.08,154.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.68,143.55c2,1,3.8,2.4,5.4,4.2l-3.6,2.2c2-0.2,3.8-1,4.8-3c0.2-0.4,0-0.8,0-1.2l-18.6-10.8 c-1.4,0-2.8-0.2-4.4,0l17.6,9.2C768.48,143.75,768.08,143.75,767.68,143.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M672.68,175.35c14.4-8.4,26.8-15,37.6-20.4C695.68,161.95,681.48,170.15,672.68,175.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M755.68,134.95l18.6,10.8c0.6-2.4-0.2-4.6-2-6.2c-0.8-0.4-1.4-1.2-2.2-1.6l-0.4-0.2 C765.68,135.55,760.88,134.95,755.68,134.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M645.68,211.15c1.6-11.8,7-24,27-35.6c9-5.2,23-13.4,37.6-20.4c0.6-0.2,1.2-0.6,1.8-0.8c4-2,8.2-3.8,12.2-5.4 c3.4-1.4,6.6-2.6,9.8-3.6c0.6-0.2,1.4-0.4,2-0.8c2.8-0.8,5.4-1.6,8-2.2c1.2-0.2,2.4-0.6,3.6-0.8c1.8-0.4,3.8-0.6,5.4-0.6 c0.6,0,1.4-0.2,2-0.2c1,0,1.6,0.2,2.6,0.2c1.2,0,2.4,0.2,3.6,0.4c1.4,0.2,2.8,0.8,4.2,1.4c0.8,0.4,1.6,0.6,2.4,1 c0.4,0.2,0.6,0.2,1.2,0.4l-17.6-9.2c-3.6,0.4-7.6,1-11.6,2c-3.8,1-8,2.2-12.4,4c-0.2,0-0.4,0.2-0.6,0.2c-5,1.8-10.4,4.2-16.2,7 c-0.2,0-0.2,0.2-0.4,0.2c-4.6,2.2-9.6,4.8-14.8,7.4c-2,1-3.6,1.8-5.6,3c-6.4,3.4-13,7.2-20.2,11.4c-18.6,11-25.8,23.8-29.8,42 l-0.4-0.2l-1,6.6l5.6,3.4L645.68,211.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.28,147.15c1.6-0.2,3.2-0.4,4.8-0.4C753.68,146.75,752.08,146.95,750.28,147.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.08,147.55l-108,62c-0.8,2.6-1.4,5.4-1.8,8.2l118.4-68c-1.2,0.2-2.4,0.4-3.4-0.2 C764.08,148.75,762.68,147.95,761.08,147.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.88,180.75c8.8-5.2,16.8-9.6,24.2-13.6C692.68,170.95,684.88,175.35,675.88,180.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M704.08,164.95c1.8-1,3.6-1.8,5.2-2.6C707.68,163.15,705.88,163.95,704.08,164.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M755.28,146.75L755.28,146.75c2,0,3.8,0.2,5.8,0.8C759.28,147.15,757.48,146.75,755.28,146.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.68,143.55c-0.8-0.4-1.6-0.6-2.4-1c-1.4-0.6-2.6-1-4.2-1.4c-1-0.2-2.4-0.4-3.6-0.4c-1.4-0.2-3-0.2-4.6,0 c-1.8,0.2-3.6,0.2-5.4,0.6c-1.2,0.2-2.4,0.4-3.6,0.8c-2.6,0.6-5.2,1.2-8,2.2c-0.6,0.2-1.4,0.4-2,0.8c-3.2,1-6.4,2.2-9.8,3.6 c-3.8,1.6-7.8,3.2-12.2,5.4c-0.6,0.2-1.2,0.6-1.8,0.8c-10.8,5.2-23.2,12-37.6,20.4c-19.2,11.4-24.8,24.2-28.6,46.6l3-1.8l4-2.4 c0.6-3,1.2-5.6,1.8-8.2l-1,0.6c1.6-9.4,6.2-19.2,23.8-29.6c9-5.4,17-9.8,24.2-13.6c1.4-0.8,2.8-1.4,4-2.2c1.8-1,3.6-1.8,5.2-2.6 c17.8-9,31.2-13.8,41-15.2c1.8-0.2,3.4-0.4,4.8-0.4h0.2c2.4,0,4,0.2,5.8,0.8h0.2l0,0c1.6,0.4,3,1,5,2c1.2,0.6,2.4,0.4,3.4,0.2 l3.6-2.2C771.48,145.95,769.68,144.75,767.68,143.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M757.68,140.95c1.2,0,2.4,0.2,3.6,0.4C760.08,141.15,758.88,141.15,757.68,140.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M724.08,148.75c3.4-1.4,6.6-2.6,9.8-3.6C730.88,146.15,727.68,147.35,724.08,148.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M747.68,141.55c2-0.4,3.8-0.6,5.4-0.6C751.28,140.95,749.48,141.15,747.68,141.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M736.08,144.35c2.8-0.8,5.4-1.6,8-2.2C741.48,142.75,738.88,143.55,736.08,144.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.28,154.95c0.6-0.2,1.2-0.6,1.8-0.8C711.48,154.35,710.88,154.75,710.28,154.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M765.28,142.75c0.8,0.4,1.6,0.6,2.4,1C766.88,143.15,766.08,142.95,765.28,142.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M672.68,175.35c-20,11.6-25.4,23.8-27,35.6l-1.6,10.8C647.88,199.55,653.48,186.75,672.68,175.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M258.28,900.15c-1.6-4.2-3-9-4-14.2c0-0.4-0.2-0.6-0.2-0.8c-0.2-0.8-0.2-2-0.2-3c-1.4-10.6-1.4-23,1.4-38 c0.2-1,0.4-2,0.6-3c2-16.4,5-34.6,8-52.4c3.6-26.2,7.6-55.4,11.8-84.4c0.8-8,1.6-16,2.4-24.4c3-31.8,6.2-65.4,11.8-97.6 c3.6-23.6,8-44.2,15-62.8c4.2-15,11-26.2,19-37.6l0,0l-139.2-80.2c-0.2,0.4-0.4,0.6-0.6,1c-3,4.2-5.6,8.6-8,12.8 c-0.4,0.8-1,1.6-1.4,2.4c-2.6,4.8-5,9.8-7,14.6c-14,35-23.4,119.8-31,188c-3.6,31.8-7,61.8-10.2,83.8c-1.2,7.2-2.6,14.8-4.2,22.8 c-7,34.4-14.6,73.4,5.6,96.2c0.8,0.8,1.8,1.6,2.8,2.6c0.2,0.2,0.4,0.2,0.4,0.4c1.6,1.2,3.4,2.4,5.2,3.8 c23.6,16.4,88,52.6,122.2,71.8C258.48,900.95,258.48,900.35,258.28,900.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M255.68,840.95c1.6-9,3.2-17.8,4.6-26.2c1-8.2,2.2-17,3.4-26.2C260.68,806.35,257.68,824.75,255.68,840.95z"
}), React.createElement("path", {
  className: "st2",
  d: "M254.08,884.95c0-0.6-0.2-1.4-0.2-2.2c0-0.2,0-0.6-0.2-0.8C253.88,882.95,253.88,884.15,254.08,884.95z"
}), React.createElement("path", {
  className: "st2",
  d: "M184.48,401.55c-0.2,0.4-0.4,0.6-0.6,1C184.08,402.15,184.28,401.75,184.48,401.55L184.48,401.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M130.88,825.55c0.2,0,0.2,0.2,0.4,0.2C131.08,825.75,130.88,825.55,130.88,825.55L130.88,825.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M289.68,582.35c-5.6,32-9,65.6-11.8,97.6c-0.8,8.4-1.6,16.4-2.4,24.4c0.6-3.4,1-7,1.6-10.4 c1.6-14.8,3.2-28.8,4.6-42C284.28,625.75,286.68,602.95,289.68,582.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M174.68,417.75c0.4-0.8,1-1.6,1.4-2.4C175.48,416.15,175.08,416.95,174.68,417.75z"
}), React.createElement("path", {
  className: "st2",
  d: "M254.28,885.95L254.28,885.95c0-0.4-0.2-0.6-0.2-0.8C254.08,885.35,254.28,885.55,254.28,885.95z"
}), React.createElement("path", {
  className: "st2",
  d: "M258.48,901.35c-34.4-19.2-98.6-55.2-122.2-71.8c29,21.4,70.4,44,107.4,64c5.2,2.8,10.2,5.4,15,8.2 c-0.2-0.4-0.2-0.8-0.4-1c0-0.2-0.2-0.2-0.2-0.4C258.48,900.35,258.48,900.95,258.48,901.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M121.68,833.75c0.6,0.4,1,0.8,1.6,1.4c30,23.4,75,47.6,114.8,69.2c15,8.2,29,15.8,42.8,23.6 c-5.4-3.2-15-8.6-26.8-15.2C195.08,879.95,137.28,847.15,121.68,833.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M102.68,781.35c0,18.6,4,36.2,16.2,49.8c0.6,0.6,1.4,1.2,2,1.8c-0.8-0.8-1.6-1.4-2-2 C106.68,817.55,102.68,800.15,102.68,781.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M165.28,409.15c0.2-0.4,0.4-0.8,0.6-1.2C165.68,408.35,165.48,408.75,165.28,409.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M330.28,472.55c0.2-0.2,0.2-0.4,0.4-0.6c0,0,0,0,0-0.2l-138.8-80.2c-1.2,1.6-2.6,3.2-3.8,5l139,80.2 C328.08,475.15,329.28,473.75,330.28,472.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.48,911.75c-41.4-22.8-94-50-130.2-76.2c-5.4-3.6-9.4-6.8-11.2-8.6c-27.4-30.6-9-85.2-3-124 c10.8-69.6,20.6-221,41.6-273c2.4-6,5.6-12,8.8-18c0.2-0.4,0.6-1,0.8-1.4c3.4-5.8,7-11.4,11-16.8c0-0.2,0.2-0.2,0.2-0.4l0,0 c1.2-1.6,2.6-3.4,3.8-5l-0.8-0.4c-2.8-1.6-6.2-0.8-8,1.6c-4.4,6-8.4,12.2-12,18.4c-0.2,0.4-0.4,0.8-0.6,1.2 c-3.4,6.2-6.6,12.2-9,18.4c-14.6,36.6-23.8,118.6-31.8,191.2c-3.6,31.6-6.8,61.6-10.2,83.2c-1.2,7-2.6,14.6-4.2,22.2 c-1,4.6-1.8,9.4-2.8,14.2c-2.6,14.4-4.8,29-4.8,43c0,18.6,4,36,16.2,49.8c0.6,0.6,1.2,1.2,2,2c0.2,0.2,0.6,0.4,0.8,0.8 c15.6,13.2,73.6,46.2,132.2,79c11.8,6.6,21.4,12,26.8,15.2c0.2,0.2,0.4,0,0.6,0.2c-1-0.6-2-1.2-2.8-1.8 C273.68,922.75,268.68,917.95,264.48,911.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M330.68,471.75c-0.2,0.2-0.2,0.4-0.4,0.6C330.48,472.15,330.68,471.95,330.68,471.75L330.68,471.75 C330.88,471.75,330.68,471.75,330.68,471.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M161.88,429.95c2.6-6,5.6-12,8.8-18C167.48,417.95,164.28,423.75,161.88,429.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M191.88,391.55l-5.4-3c-1.2,1.6-2.6,3.2-3.8,5l5.2,3C189.28,394.75,190.68,393.15,191.88,391.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M171.48,410.55c3.4-5.8,7-11.4,11-16.8C178.48,399.35,174.88,404.95,171.48,410.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M123.28,826.95c1.8,2,5.8,5,11.2,8.6c-2.4-1.8-5.2-3.6-7.6-5.4C125.68,829.15,124.48,828.15,123.28,826.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M176.08,415.35c2.4-4.2,5-8.6,8-12.8C181.08,406.55,178.48,410.95,176.08,415.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.08,476.55l-139-80.2c-1.2,1.6-2.4,3.4-3.4,5l139,80.4C324.88,479.95,325.88,478.35,327.08,476.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M136.28,829.55c-1.6-1.2-3.4-2.6-5.2-3.8C132.68,826.95,134.28,828.15,136.28,829.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M130.68,825.35c-1-0.8-2-1.6-2.8-2.6C128.68,823.55,129.48,824.55,130.68,825.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M263.68,788.75c0.6-3.2,1-6.2,1.6-9.2c1.8-10,3.4-19.2,4.6-27.6c1-7.6,2-15.2,3-22.4c1-8.2,1.8-16.4,2.8-25 C271.28,733.35,267.08,762.55,263.68,788.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M167.68,432.15c2-4.8,4.4-9.6,7-14.6C172.08,422.35,169.68,427.35,167.68,432.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.68,481.75c-8,11.6-14.8,22.8-19,37.6C309.48,506.15,315.68,493.75,323.68,481.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M182.68,393.35c0,0.2-0.2,0.2-0.2,0.4C182.68,393.55,182.68,393.55,182.68,393.35L182.68,393.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M170.68,411.95c0.2-0.4,0.6-1,0.8-1.4C171.28,411.15,171.08,411.55,170.68,411.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M134.48,835.75c36,26.2,88.8,53.4,130.2,76.2l-0.2-0.2C228.08,891.35,161.68,854.35,134.48,835.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M254.28,885.95c-0.2-1-0.2-2-0.4-3.2c0,0.8,0,1.8,0.2,2.2C254.08,885.35,254.28,885.55,254.28,885.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M263.68,788.75c-1.2,9.2-2.4,17.8-3.4,26.2c3.8-22.6,7-43.4,9.6-63c-1.4,8.2-3,17.6-4.6,27.6 C264.68,782.35,264.08,785.55,263.68,788.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M272.68,729.35c1.6-12.4,3-24.2,4.2-35.4c-0.6,3.4-1,7-1.6,10.4C274.68,712.95,273.68,721.15,272.68,729.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M258.48,900.55c0.2,0.4,0.2,0.8,0.4,1c-4.8-2.6-10-5.4-15-8.2c-36.8-20-78.2-42.6-107.4-64 c-2-1.4-3.8-2.6-5.2-3.8c-0.2,0-0.2-0.2-0.4-0.2l0,0c-1.2-1-2.2-1.8-2.8-2.6c-20.4-22.8-12.6-61.8-5.6-96.2c1.6-8,3-15.6,4.2-22.8 c3.4-21.8,6.6-52,10.2-83.8c7.4-68.2,16.8-153,31-188c2-5,4.4-9.8,7-14.6c0.4-0.8,1-1.6,1.4-2.4c2.4-4.4,5.2-8.6,8-12.8 c0.2-0.4,0.4-0.6,0.6-1l0,0c1.2-1.6,2.2-3.4,3.4-5l-5.2-3c0,0.2-0.2,0.2-0.2,0.4c-4,5.4-7.6,11.2-11,16.8c-0.2,0.4-0.6,1-0.8,1.4 c-3.4,5.8-6.4,11.8-8.8,18c-20.8,52-30.8,203.4-41.6,273c-6,39-24.4,93.4,3,124c1.2,1.2,2.2,2.2,3.6,3.2c2.4,1.8,5,3.6,7.6,5.4 c27.2,18.6,93.6,55.6,130,75.8C262.08,908.35,260.08,904.75,258.48,900.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M662.68,548.55l-51,29.6c30,18.4,76.4,44.4,102.8,59.4c-1-2.4-1.8-4.8-2.6-7.2c-4.6-13.8-6.4-28.6-7.8-42.2 l-4.6-28.4c-0.2-1.2-0.6-2.6-1-4.2c-0.8-2-1.6-3.8-2.4-5.4c-0.2-0.4-0.4-0.6-0.6-1c-1.2-1.2-3.6-3.2-7.2-5.6 C681.68,541.35,672.48,542.95,662.68,548.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M719.48,647.35c-30.2-17-81.8-46-113.8-65.6l-6,3.6c26.4,16.4,69.2,40.6,112.2,65c11,6.2,19.6,11,24.6,13.8 c0.4,0.2,0.8,0.2,1.4,0.4C730.48,660.15,724.28,654.75,719.48,647.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M696.28,550.15c1,1.6,1.8,3.4,2.4,5.4C698.28,553.75,697.48,551.95,696.28,550.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M709.08,618.75l-4.8-30.6c1.4,13.6,3.2,28.4,7.8,42.2C710.88,626.55,709.88,622.95,709.08,618.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M611.88,578.35l-6,3.4c32,19.6,83.6,48.6,113.8,65.6c-2-3-3.4-6.4-5-9.8 C688.28,622.75,641.88,596.55,611.88,578.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M689.88,544.15c-0.4-0.2-1-0.2-1.4-0.4c3.6,2.4,6,4.4,7.2,5.6C694.28,547.15,692.48,545.35,689.88,544.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M483.08,372.35c-1.4,0.6-3,1.2-4.6,2c-1.8,1-3.8,2-5.8,3.2c-22.4,13-41.6,25-58.2,36.4 c-30,21.8-60,47.2-73.8,65.4c-11.8,15.4-20.2,34.6-26.8,55.6c-2.4,15.2-13.4,85.6-24.2,159.2c-4,35.6-9.2,76.6-17.4,124.8 c-4.2,33-6.6,57.2-6,63.4c0,0.6,0.2,1.2,0.4,1.6c0.6,2.8,1.2,5.4,2,8c0.4,1,0.6,2,1,3c0.8,2.2,1.8,4,2.8,6c0.4,0.8,0.8,1.8,1.4,2.6 c3.2,5.2,7.6,9.6,12.8,13.4c21.8,14.8,49.6,4.6,69-6.8l1.8-1c47.8-27.8,88.2-88,96-143l10.2-70.4c4-28.4,24.8-59.6,49.6-74 l75.2-43.8c-7-4.6-12-8.4-14-10.6c-0.6-0.6-1-1.6-1.4-2.4l-5.2,3c-1,0.6-2,0.8-3.2,0.8c-1,0-2-0.2-3.2-0.8c-2-1.2-3.2-3.2-3.2-5.4 l0.2-20.6c0-1.6,0.8-3,1.8-4c-3-11.4-4.4-23.6-5.6-35c-2.2-20-4.2-38.8-13.8-45c-2.8-1.8-3.4-5.6-1.8-8.4c1.8-2.8,5.4-3.8,8.4-2 c4,2.4,12,6.8,22.2,12.6c68.4,38.2,106.2,60.2,124,72.4c0.6,0.2,1,0.2,1.6,0.4c4,1.8,7.2,4.8,10,8.4c0.2,0.2,0.4,0.4,0.4,0.6 c0.2,0.2,0.4,0.4,0.6,0.8c0,0.2,0.2,0.2,0.2,0.4c0.6,1,1,2.2,1.6,3.2c0.6,1.2,1.2,2.4,1.8,3.8c3.8,9.6,5,21.8,6.4,34.6l5.2,32.2 c0.6,3.6,1.6,6.8,2.4,10c3.4,9.8,8.6,18.4,16.6,24.6c1.8,1.4,3.6,2.8,5.8,3.8c16.8,8,39.4,4.4,64.2-10l1.8-1 c29.8-17.4,55.6-45.4,74.8-81.2c19.6-36.6,26.8-70,20.8-96.6c-14.2-64.2-20.2-119.2-24.8-163.4c-6.6-60.4-11-100.6-31.2-112.6 c-11.8-5-30-3.6-52.8,4c-22,8.2-50.2,22.4-87.2,44c-2.8,1.6-5.2,3.2-7.4,4.8c-0.6,0.4-1.4,1-2,1.4c-2,1.4-3.8,2.8-5.4,4.4 c-0.4,0.4-0.8,0.8-1.2,1.2c-1.6,1.6-3.2,3.2-4.6,4.8c-0.2,0.2-0.6,0.6-0.8,0.8c-1.4,1.6-2.8,3.4-4,5c-0.2,0.2-0.2,0.4-0.4,0.6 c-1.2,1.8-2.2,3.4-3.2,5.2c0,0.2-0.2,0.4-0.2,0.4c-0.8,1.6-1.6,3.2-2.4,4.8c-0.2,0.4-0.4,0.6-0.4,1c-0.4,1-0.8,2-1.2,3 c-1,2.6-2,5.2-3,8c-0.2,0.4-0.2,0.6-0.4,1c-4.8,13.2-9.8,26.6-27,36.6l-6,3.6c-52,31.6-81.2,48.4-98.4,57.2l-7.6,4.4 c-5.8,3.4-10.4,4.6-14.2,4.8c-0.6,0.2-1.2,0.2-1.6,0.2s-0.8-0.2-1.4-0.2h-0.2c-2-0.2-3.8-0.8-5.4-1.6c-0.2,0-0.4-0.2-0.6-0.2 L483.08,372.35z M497.68,541.15c0,13.8-9.4,30-21.4,37l-20,11.8l-0.2,23.4c0,13.8-9.4,30-21.4,37l-13.8,8 c-3.6,2.2-7.6,3.4-11.2,3.4c-3,0-5.6-0.6-7.8-2c-5.4-3-8.4-9.4-8.4-17.2v-16l-13.8,8c-6.8,4-13.8,4.4-19.2,1.4 c-5.4-3-8.4-9.4-8.4-17.2v-15.8c0.2-13.8,9.6-30,21.4-37l20.2-11.8l0.2-23.4c0-13.8,9.4-30,21.4-37l13.6-8c6.8-4,13.8-4.4,19-1.4 c5.2,3.2,8.4,9.4,8.4,17.2l-0.2,16l14-8c6.8-4,13.8-4.4,19.2-1.4c5.4,3,8.4,9.4,8.4,17.2V541.15z M810.08,270.55 c10.2-5.8,19.8-6.6,27.6-2c7.6,4.4,11.8,13.2,11.8,25c0,21.6-14.6,47-33.4,57.8c-5.8,3.4-11.2,5-16.4,5c-4,0-7.8-1-11.2-2.8 c-7.6-4.4-11.8-13.4-11.8-25C776.68,306.75,791.28,281.35,810.08,270.55z M743.68,380.95c10-5.8,19.8-6.6,27.6-2 c7.6,4.4,12,13.2,12,25c0,21.6-14.8,47-33.6,57.8c-5.8,3.4-11.4,5-16.6,5c-4,0-7.6-1-11-2.8c-7.8-4.4-12-13.4-12-25 C710.28,417.15,724.88,391.75,743.68,380.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M520.28,391.55c0.4,0,1,0,1.6-0.2c-1.2,0-2.2,0-3.2,0h0.2C519.28,391.35,519.88,391.35,520.28,391.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M690.08,255.75c0.2-0.2,0.6-0.6,0.8-0.8C690.68,255.15,690.28,255.35,690.08,255.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M679.48,272.75c0.2-0.4,0.4-0.6,0.4-1C679.68,272.15,679.48,272.55,679.48,272.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M647.88,321.15l-104.2,60.8c17.2-8.8,46.4-25.6,98.4-57.2L647.88,321.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M702.08,244.75c0.6-0.4,1.4-1,2-1.4C703.48,243.75,702.68,244.15,702.08,244.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M478.48,374.35c1.6-0.6,3.2-1.4,4.6-2l29.4,17c0.2,0.2,0.4,0.2,0.6,0.2c-4.8-2.6-7.6-7.2-9.8-10.8 c-0.6-1-1.2-2-1.8-2.8l-10-5.8C488.48,370.15,484.28,371.55,478.48,374.35z"
}), React.createElement("path", {
  className: "st0",
  d: "M695.48,250.15c0.4-0.4,0.8-0.8,1.2-1.2C696.28,249.35,695.88,249.75,695.48,250.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M678.28,275.75c-1.2,2.8-2.2,5.6-3.2,8.4c0,0.2-0.2,0.4-0.2,0.6c0.2-0.4,0.2-0.6,0.4-1 C676.28,281.15,677.08,278.35,678.28,275.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M682.28,266.95c0-0.2,0.2-0.4,0.2-0.4C682.48,266.75,682.28,266.95,682.28,266.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M685.68,261.35c0.2-0.2,0.2-0.4,0.4-0.6C686.08,260.95,685.88,261.15,685.68,261.35z"
}), React.createElement("path", {
  className: "st0",
  d: "M313.68,534.95c6.6-21,15.2-40.2,26.8-55.6c13.8-18.2,43.8-43.6,73.8-65.4c-36,24.4-60.2,45.8-76.6,68.8 c-0.2,0.2,0,0.6-0.2,0.8l-0.4,0.4c-2.4,3.4-4.8,6.8-7,10.2c-0.4,0.6-0.8,1.2-1.2,1.8c-0.2,0.4-0.4,0.8-0.8,1.2 c-4.6,8-8.4,16.4-11.6,25c-1,3.2-2,6.6-2.6,10.2C314.08,532.75,313.88,533.75,313.68,534.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M851.48,190.55c-0.6-0.2-1-0.8-1.4-1c-10.8-5.4-27.2-4-51.4,5C821.68,186.95,839.68,185.55,851.48,190.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M492.08,369.95c-0.2,0-0.4,0-0.6,0l10,5.8C499.28,372.55,496.88,369.95,492.08,369.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M289.48,694.15c10.8-73.6,21.8-144,24.2-159.2c-5,16-9,33-12,50.6c-2.8,19.8-5.2,42-7.8,67.6 C292.48,665.95,291.08,679.55,289.48,694.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M272.08,818.95c-1.4,8.4-3,16.8-4.6,25.6c-1.8,15.8-2.6,29.4-1.4,37.8l0,0 C265.48,876.15,267.88,851.95,272.08,818.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M328.48,496.75c0.2-0.4,0.4-0.8,0.8-1.2C329.08,496.15,328.68,496.35,328.48,496.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M337.68,483.35c0.2-0.2,0-0.6,0.2-0.8c-2.6,3.8-5.2,7.6-7.4,11.4c2.2-3.4,4.4-6.6,7-10.2L337.68,483.35z"
}), React.createElement("path", {
  className: "st0",
  d: "M272.28,900.95c-1-2-2-3.8-2.8-6C270.28,897.15,271.28,899.15,272.28,900.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M267.48,844.55c-0.2,0.6-0.2,1-0.2,1.6c-2.6,13.6-2.8,25.6-1.2,36.2 C264.88,873.95,265.68,860.35,267.48,844.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M314.28,532.15c0.6-3.8,1.6-7,2.6-10.2c-7,18.6-11.6,39.4-15.2,63.6c3.2-17.6,7-34.8,12-50.6 C313.88,533.75,314.08,532.75,314.28,532.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M268.48,891.95c-0.8-2.6-1.4-5.2-2-8C267.08,886.75,267.68,889.55,268.48,891.95z"
}), React.createElement("path", {
  className: "st0",
  d: "M273.68,903.55c3.2,5,7,9.2,11.8,12.8c0.4,0.2,0.8,0.4,1,0.6C281.28,913.15,277.08,908.75,273.68,903.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M563.68,470.75c-0.6-0.4-1.4-0.8-2-1.2c2.8,9.4,4,20.4,5.2,32c1,10,2.2,20,4.2,29.4l48.8-28.4 C598.08,489.95,576.68,478.15,563.68,470.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M670.28,532.15c-9.8-6-21.6-13-34-20.2v12.2c0,2.2-1.2,4.2-3.2,5.4l-50,29.2c0.2,0.2,0.2,0.2,0.2,0.4 c1.8,2.2,8,6.4,16.4,11.8l56.6-33C661.28,535.15,665.88,533.55,670.28,532.15z"
}), React.createElement("path", {
  className: "st0",
  d: "M547.28,447.35c-3-1.6-6.6-0.8-8.4,2c-1.8,2.8-1,6.6,1.8,8.4c9.6,6.4,11.6,25.2,13.8,45 c1.2,11.4,2.6,23.6,5.6,35c0.4-0.4,0.8-1,1.2-1.4l4.2-2.4c-7.4-31.2-3.6-69.6-21.2-81.4c10.6,6.2,46.8,26.2,81.8,46.2l1.2-0.6 c1.8-1.2,4.4-1.2,6.4,0c1.8,1.2,3,3.2,3,5.4v1.2c16,9.2,31.2,18.2,42.8,25.6c5.2-0.4,10,0.2,14.4,2c-18-12.2-55.8-34.2-124-72.4 C559.28,454.35,551.28,449.75,547.28,447.35z"
}), React.createElement("path", {
  className: "st0",
  d: "M577.88,561.75l-5.2,3c0.6,0.8,0.8,1.6,1.4,2.4c2,2.2,7,6,14,10.6l6-3.4c-7.8-5-13.4-9-15.2-11.2 C578.48,562.75,578.08,562.15,577.88,561.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M711.88,557.75l4.2,26.8c-1.2-13-2.6-25.2-6.4-34.6C710.68,552.35,711.48,554.95,711.88,557.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M706.28,542.55c0.8,1,1.2,2.4,1.8,3.6c-0.6-1-1-2.4-1.6-3.2C706.48,542.95,706.28,542.75,706.28,542.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M723.88,626.75c3.4,10.8,9,19.2,16.6,24.6C732.28,645.15,727.28,636.55,723.88,626.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M705.08,541.35c0.2,0.2,0.4,0.4,0.4,0.6C705.48,541.75,705.28,541.55,705.08,541.35z"
}), React.createElement("path", {
  className: "st0",
  d: "M566.88,501.55c-1.2-11.4-2.4-22.4-5.2-32c0.6,0.4,1.4,0.8,2,1.2c13,7.4,34.4,19.2,56.2,31.8l6.2-3.6 c-35-20-71.2-40-81.8-46.2c17.8,11.8,14,50.2,21.2,81.4l5.6-3.2C569.08,521.55,567.88,511.55,566.88,501.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.28,558.75l-5.4,3.2c0.4,0.4,0.6,1,1,1.4c2,2.2,7.6,6.2,15.2,11.2l6-3.4c-8.6-5.4-14.6-9.8-16.4-11.8 C583.28,558.95,583.28,558.75,583.28,558.75z"
}), React.createElement("path", {
  className: "st0",
  d: "M636.28,511.95c12.4,7.2,24.2,14.2,34,20.2c3-0.8,6-1.4,8.8-1.8c-11.6-7.4-26.8-16.2-42.8-25.6V511.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.08,626.95c-23.2,13.6-42.8,42.6-46.6,69.4l-10.2,70.4c-8,56.8-49.6,118.8-98.8,147.6l-1.8,1 c-27.2,15.8-51,19.2-69.6,10.2c0,0.2,0,0.2,0,0.4c-1.2,1.8-3.2,2.8-5.2,2.8c-0.8,0-1.6-0.4-2.6-0.6c7.4,4.8,17.4,8.6,30.2,8.6 c13.6,0,30.2-4.2,50.4-16l1.8-1c50.8-29.6,93.6-93.6,101.8-152l10.2-70.4c3.4-25,22-52.4,43.6-65l80.6-47c-2-1.2-4-2.6-5.8-3.8 L516.08,626.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M894.88,301.75c-7-65-11.6-105.2-35.8-120.8c2,1.8,2.8,4.8,1.6,7.2c-0.2,0.4-0.6,0.4-0.8,0.6 c32.4,29,21,128.6,53.8,276.4c6.4,28.6-1.8,63.8-21.4,100.8c-19.8,37-46.4,65.8-77.2,83.8l-1.8,1c-26.6,15.6-50.6,18.2-68.6,10.4 c-0.2,0.2,0,0.6-0.2,1c-1.2,1.8-3.2,3-5.4,3c-0.6,0-1-0.2-1.6-0.4c1.2,0.6,2,1.6,3.2,2c20.4,9.6,47.2,6,75.6-10.6l1.8-1 c31.6-18.4,59.2-48.2,79.4-86.2c21-39.2,28.6-75.6,22.2-105C905.48,400.35,899.68,345.75,894.88,301.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.08,242.15c1-1,2.4-2,3.6-3C688.48,239.95,687.28,240.95,686.08,242.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.08,288.75c1.2-3,2.4-6,3.4-9.2c2-5.6,4.2-11.4,7.2-17.2c-3.2,6-5.4,12-7.4,17.6 C662.28,283.15,661.28,285.95,660.08,288.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M399.48,409.55c-28.6,20.2-49.6,38.8-65.2,58C348.68,450.35,373.48,428.95,399.48,409.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.68,361.75c0.4-0.2,0.6-0.2,1-0.4C477.28,361.35,477.08,361.55,476.68,361.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.08,232.55c-1.4,1-3,2-4.2,3C695.08,234.75,696.48,233.75,698.08,232.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M533.48,373.55c14.6-7.4,43.8-23.8,102-59.2l6.2-3.6c1.2-0.8,2-1.6,3-2.4c-1,0.8-1.8,1.6-3,2.2L533.48,373.55z "
}), React.createElement("path", {
  className: "st1",
  d: "M482.68,359.55c1.4-0.2,3-0.2,4.2,0.6l6.8,3.8c5.4,0.4,8.8,3,11.4,6.4l11.6,6.4c-0.8-1.2-1.8-2.6-2.8-4.4 C508.08,362.55,500.48,354.15,482.68,359.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.88,379.15c0.2,0,0.4-0.2,0.6-0.2c-0.2,0-0.6,0-0.8,0L520.88,379.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M656.28,296.55c0,0,0,0.2-0.2,0.2C656.08,296.75,656.28,296.55,656.28,296.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.68,251.55c-0.8,1.2-1.8,2.2-2.6,3.4C675.88,253.95,676.68,252.75,677.68,251.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M682.88,245.35c-1,1-2,2.2-3,3.2C680.88,247.55,681.88,246.35,682.88,245.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M825.88,175.55l-1.2-0.6c-7.8,1-16.4,3.2-26.4,6.6C807.88,178.55,817.28,176.35,825.88,175.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M673.48,257.55c-0.8,1.4-1.6,2.8-2.4,4C671.88,260.35,672.68,258.95,673.48,257.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M835.88,174.15l19.6,11.2l0,0c1.6,1,3.2,2.2,4.6,3.6c0.2-0.2,0.6-0.4,0.8-0.6c1.4-2.6,0.4-5.4-1.6-7.2 c-1.2-0.8-2.2-1.8-3.6-2.6C849.88,175.55,843.28,174.15,835.88,174.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.68,372.15c3-1.8,5.6-3,8-4.2c-17.2,7.2-43.8,24-70,43.2C425.28,398.95,445.68,386.15,469.68,372.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M702.08,237.35c2-1.4,4-2.8,6.4-4.2c39-22.8,68.8-37.8,92-45.8c-36.4,11.4-76.4,35.8-96.4,48.6 C703.28,236.35,702.68,236.75,702.08,237.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M688.28,248.55c1-1,2-2.2,3.2-3.2C690.48,246.55,689.28,247.55,688.28,248.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M532.88,380.95l5-3c-8.2,4.2-14.2,6.8-17,7C524.08,385.15,527.88,383.95,532.88,380.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M644.88,315.95c8.2-4.8,13.4-10.4,17-16.6C658.08,305.35,653.08,310.95,644.88,315.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.68,268.15c0,0.2-0.2,0.4-0.2,0.6C674.68,268.55,674.68,268.35,674.68,268.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.68,297.75c-0.2,0.4-0.4,0.8-0.6,1.2C662.28,298.35,662.48,297.95,662.68,297.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M519.88,385.15l-3.8-1C517.08,384.75,518.28,384.95,519.88,385.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.08,474.95C336.08,474.95,336.08,475.15,336.08,474.95c1-1.2,2.2-2.6,3.2-3.8 C338.08,472.55,336.88,473.75,336.08,474.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M482.68,365.95c0.4-0.2,0.6-0.2,1-0.4l0,0C483.48,365.75,483.08,365.75,482.68,365.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.08,250.95c-1,1.2-1.8,2.2-2.8,3.4C684.28,253.15,685.08,251.95,686.08,250.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M681.68,256.55c-0.8,1-1.4,2.2-2.2,3.2C680.08,258.55,680.88,257.55,681.68,256.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.88,262.15c-0.4,0.8-0.8,1.6-1.4,2.4C677.08,263.75,677.48,262.95,677.88,262.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.08,239.95c-1.2,1-2.4,1.8-3.6,2.8C695.68,241.95,696.88,240.95,698.08,239.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M482.68,359.55c-1.6,0.4-3.2,1-4.8,1.6c-0.4,0.2-0.6,0.2-1,0.4c-3,1.4-6.4,3-10,5.2 c-26.4,15.4-48.4,29.4-67.2,42.6c-26,19.4-50.8,40.8-65.2,58c-1.2,1.4-2.4,2.8-3.4,4.4l4.6,2.6c0.2,0.2,0.2,0.4,0.4,0.6 c1-1.2,2-2.6,3.2-3.8c16-19.8,38-39,68.6-60.2c26.2-19.2,52.8-35.8,70-43.2c1.8-0.8,3.4-1.4,5-2c0.2-0.2,0.6-0.2,1-0.4l0,0 c4-1.4,7.2-1.8,10-1.6l-6.8-3.8C485.48,359.55,483.88,359.35,482.68,359.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M824.88,174.75l1.2,0.6c-8.6,0.8-18,3-27.6,6c-23.4,8.2-53.2,23.2-93,46.4c-2.6,1.6-5,3.2-7.4,4.8 c-1.4,1-3,2-4.2,3c-1.4,1-2.8,2.2-4,3.2s-2.4,2-3.6,3c-1.2,1-2.2,2.2-3.2,3.2c-1,1-2,2.2-3,3.2c-0.8,1-1.6,2-2.4,3 c-0.8,1.2-1.8,2.2-2.6,3.4c-0.6,0.8-1,1.6-1.6,2.4c-0.8,1.4-1.6,2.8-2.4,4c-0.2,0.2-0.2,0.4-0.4,0.8c-3,6-5.2,11.8-7.2,17.2 c-1.2,3.2-2.2,6.4-3.4,9.2c-1.2,2.8-2.4,5.2-3.8,7.6c0,0,0,0.2-0.2,0.2c-2.6,4.2-6.4,8-11.4,11.6c-1,0.8-1.8,1.6-3,2.4l-6.2,3.6 c-58.4,35.6-87.6,52-102,59.2l-3.8,2.2c-4,2.2-6.2,3-8.2,3.2c-0.2,0-0.4,0.2-0.6,0.2l-0.2-0.2c-1.6-0.2-2.8-0.8-4-2.2l-11.6-6.4 c3.8,4.8,6,11,10.8,13.6l3.8,1c0.4,0,0.8,0,1.2,0c2.8-0.2,8.8-3,17-7l106.8-62.2c8.2-5,13.4-10.6,17-16.6c0-0.2,0.2-0.2,0.2-0.4 c0.2-0.4,0.4-0.8,0.6-1.2c4.8-8.8,7.2-18.8,11.8-28.8c0-0.2,0.2-0.4,0.2-0.6c0.6-1.2,1.2-2.4,1.8-3.6c0.4-0.8,0.8-1.6,1.4-2.4 c0.4-0.8,1-1.8,1.6-2.6c0.6-1,1.4-2.2,2.2-3.2c0.6-0.8,1.2-1.6,1.8-2.2c0.8-1.2,1.8-2.2,2.8-3.4c0.6-0.8,1.4-1.6,2.2-2.4 c1-1,2-2,3.2-3.2c1-0.8,2-1.6,3-2.6c1.2-1,2.4-1.8,3.6-2.8c1.2-1,2.6-1.8,4-2.8c0.6-0.4,1.2-0.8,2-1.4c20-12.8,60-37.2,96.4-48.6 c25.6-9,43-9.4,55-2l0,0l-19.6-11.2C832.48,173.95,828.68,174.35,824.88,174.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.68,519.55c-6.8,18.6-11.4,39.2-15,62.8c3-17.6,7-34.4,12-50.4c0.2-1,0.2-1.8,0.2-1.8 C302.68,526.35,303.68,522.95,304.68,519.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M253.68,881.95c-1.2-10-0.2-24.4,1.8-41c-0.2,1-0.4,2-0.6,3C252.28,858.95,252.28,871.35,253.68,881.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M254.28,885.95c1,5.2,2.2,10,4,14.2C256.48,895.75,255.28,890.95,254.28,885.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.68,481.75L323.68,481.75L323.68,481.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M253.68,881.95c0,0.2,0,0.6,0.2,0.8c-0.4-9.2,2.2-34.6,6.4-68c-1.4,8.4-3,17.2-4.6,26.2 C253.48,857.55,252.68,871.95,253.68,881.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M281.48,651.95c-1.4,13-2.8,27-4.6,42c11.2-76.8,22.8-149.8,24.8-162c-5,16-9,33-12,50.4 C286.68,602.95,284.28,625.75,281.48,651.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M258.28,900.15c0,0.2,0.2,0.2,0.2,0.4c-1.8-4.4-3.2-9.4-4.2-14.6l0,0 C255.28,890.95,256.48,895.75,258.28,900.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.08,476.55l0.4,0.2c1-1.4,1.8-3,2.8-4.4C329.28,473.75,328.08,475.15,327.08,476.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.48,885.55c-0.2-0.6-0.4-1.4-0.4-2c0,0.2,0,0.4,0,0.6C260.28,884.55,260.48,884.95,260.48,885.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.28,815.95c4-24,7.4-46,10.2-66.6c-1.6,11-4,24.4-6.4,38.6C268.68,797.75,267.48,807.15,266.28,815.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.48,475.55c-0.4,0.6-0.8,1.4-1.4,2c0.6-0.8,1.2-1.6,1.8-2.6l0,0 C335.88,475.15,335.68,475.35,335.48,475.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M262.68,894.15c0.4,1,0.8,2,1,3C263.48,896.15,263.08,895.15,262.68,894.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M279.08,728.35c1.4-11.8,2.8-23,4-33.6c-0.6,3.4-1,6.8-1.4,10.2C280.88,712.95,280.08,720.75,279.08,728.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M267.08,904.35c0.4,0.8,0.8,1.6,1.2,2.2C267.88,905.75,267.48,904.95,267.08,904.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M288.88,925.75c0-0.2,0-0.2,0-0.4c-2-1-3.8-2.2-5.6-3.4c0.2,0.2,0.2,0.2,0.4,0.4l-1.4-0.8 c-5.6-3.2-11.6-6.6-17.8-10c4.2,6.2,9,11,13.8,14.4c0.8,0.6,2,1.2,2.8,1.8c0.8,0.4,1.8,0.6,2.6,0.6 C285.88,928.75,287.68,927.75,288.88,925.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M310.68,521.15c4.6-12,10-23.4,17.2-34.4C320.48,497.35,314.48,507.75,310.68,521.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.88,787.95c2.4-14.2,4.8-27.4,6.4-38.6c1-7.2,1.8-14.2,2.8-21c0.8-7.6,1.8-15.4,2.6-23.4 C277.48,733.55,273.48,762.15,269.88,787.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.08,474.95c-0.2-0.2-0.2-0.4-0.4-0.6l-4.6-2.6c-0.2,0.2-0.4,0.4-0.6,0.8c-1,1.4-1.8,3-2.8,4.4l5,3 c-0.2,0.4-0.4,0.6-0.8,1c0.8-1,1.4-2.2,2.2-3.2c0.4-0.6,0.8-1.4,1.4-2C335.68,475.35,335.88,475.15,336.08,474.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M271.68,739.55c0.4-3.2,0.8-6.8,1.2-10.2c-1,7.2-2,14.8-3,22.4C270.48,747.35,271.08,743.15,271.68,739.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.68,481.75L323.68,481.75L323.68,481.75c-8,12-14.2,24.4-19.2,37.8c-1,3.4-2,6.8-2.6,10.6 c0,0.2-0.2,0.8-0.2,1.8c6.4-20.6,14.8-39.2,25.8-55.2l-0.4-0.2C325.88,478.35,324.88,479.95,323.68,481.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.48,911.75c6.2,3.4,12.2,6.8,17.8,10l1.4,0.8c-4.2-2.4-11.2-6.4-19.4-11 C264.48,911.75,264.48,911.75,264.48,911.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M261.48,842.75c1.6-9.2,3.2-18.2,4.8-26.8c1.2-8.8,2.4-18.2,3.6-28C266.88,806.15,263.68,825.55,261.48,842.75 z"
}), React.createElement("path", {
  className: "st1",
  d: "M281.68,704.95c0.4-3.4,1-6.8,1.4-10.2c5.2-47,8.4-84.4,13.4-116C288.88,619.55,285.68,664.15,281.68,704.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.08,883.95c0-0.2,0-0.4,0-0.6v-0.2C260.08,883.35,260.08,883.75,260.08,883.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M268.48,906.55c-0.4-0.8-0.8-1.6-1.2-2.2c-1.2-2.2-2.4-4.6-3.4-7.2c-0.4-1-0.8-2-1-3c-0.8-2.8-1.6-5.6-2.2-8.6 c0-0.6-0.2-1-0.4-1.6c0-0.2,0-0.6,0-0.8c-1.8-11-1.6-23.8,1-38c0.2-0.8,0.2-1.6,0.4-2.4c2-17.2,5.2-36.6,8.4-54.8 c3.4-25.8,7.6-54.4,11.6-83c4-40.8,7.2-85.2,14.8-126.2c3.4-21.4,7.8-40.2,14.2-57.4c3.8-13.4,10-23.8,17.2-34.4c1.2-2,2.8-4,4.2-6 c0.2-0.4,0.4-0.6,0.8-1l-5-3c-11,15.8-19.4,34.6-25.8,55.2c-2,12.2-13.4,85.2-24.8,162c-1.2,11.2-2.6,23-4.2,35.4 c-0.4,3.4-0.8,6.8-1.2,10.2c-0.4,3.6-1.2,7.8-1.8,12.2c-2.6,19.6-5.8,40.4-9.6,63c-4.2,33.4-6.8,58.8-6.4,68c0.2,1,0.2,2.2,0.4,3.2 c1,5.2,2.4,10.2,4.2,14.6c1.8,4.2,3.8,7.8,6,11.2c8.2,4.6,15.2,8.4,19.4,11c-0.2-0.2-0.2-0.2-0.4-0.4c-0.4-0.4-1-0.6-1.4-0.8 C276.48,917.35,271.88,912.35,268.48,906.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.88,574.55c2,1.2,3.8,2.4,6,3.6l51-29.6c9.8-5.8,19-7.4,25.8-5c-3-2-6.4-4.4-10.6-7 c-5.6,0.8-11.8,2.8-18.2,6.6L605.88,574.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M704.28,588.15c0-0.6-0.2-1-0.2-1.6c-1.2-11.8-2.4-23-5.4-31c0.4,1.4,0.8,2.8,1,4.2L704.28,588.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M714.68,637.55c-1-2.4-1.8-4.8-2.6-7.4C712.88,632.75,713.68,635.35,714.68,637.55L714.68,637.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M696.08,549.75c0-0.2-0.4-0.2-0.4-0.4c0.2,0.4,0.4,0.6,0.6,1C696.28,549.95,696.28,549.75,696.08,549.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M721.68,637.95c0.8,1.8,1.8,3.6,3,5.2C723.68,641.55,722.68,639.75,721.68,637.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M703.68,550.95L703.68,550.95L703.68,550.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.08,655.35c-2-1.6-3.8-3.4-5.4-5.4C731.28,651.75,733.08,653.55,735.08,655.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M715.28,617.75l-5-31c1.6,14.8,3.2,31,8.6,44.8C717.48,627.35,716.08,622.95,715.28,617.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M700.88,545.95c-2.8-4-6.2-6.8-10.6-8.4C695.88,541.35,699.68,544.35,700.88,545.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.88,578.15l-6,3.6c1.8,1.2,3.8,2.4,5.8,3.8l6-3.6C603.68,580.55,601.88,579.35,599.88,578.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M744.68,661.95c0.2-0.2,0-0.6,0.2-1c-2.4-1-5-2.2-7.2-3.6c0.6,0.4,1,1,1.6,1.4c-4.2-2.4-11.2-6.4-19.8-11.2 c4.6,7.2,10.8,12.8,18.2,17c0.6,0.2,1,0.4,1.6,0.4C741.48,664.95,743.68,663.75,744.68,661.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.88,574.55l-6,3.4c2,1.2,3.8,2.4,6,3.6l6-3.4C609.68,576.95,607.68,575.75,605.88,574.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M729.68,649.95c-1.8-2-3.4-4.4-5-6.8c-1-1.6-2-3.4-3-5.2c-1-2-2-4-2.8-6.2c-5.4-14-7.2-30-8.6-44.8l-4.4-28.2 c-0.4-2.8-1.2-5.4-2-7.6l0,0c-0.8-2-1.8-3.6-2.8-5c-1.2-1.6-5-4.6-10.6-8.4c-3.8-1.2-8-1.6-12.6-0.8c4.2,2.6,7.8,5,10.6,7 c0.4,0.2,1,0.2,1.4,0.4c2.6,1.2,4.4,3,5.8,5.2c0.2,0.2,0.4,0.4,0.4,0.4c0,0.2,0.2,0.4,0.2,0.6c1,1.8,1.8,3.6,2.4,5.4 c2.8,8,4,19.2,5.4,31c0,0.6,0.2,1,0.2,1.6l4.8,30.6c0.6,4.2,1.8,7.8,3,11.4c0.8,2.4,1.6,5,2.6,7.4l0,0c1.4,3.4,3,6.8,5,9.8 c8.6,4.8,15.8,8.8,19.8,11.2c-0.6-0.4-1.2-1-1.6-1.4c-1-0.6-1.8-1.4-2.6-2C733.08,653.55,731.28,651.75,729.68,649.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M472.68,377.55c2.2-1.2,4-2.2,5.8-3.2c-16,7.2-40,22-64.2,39.4C431.28,402.55,450.28,390.55,472.68,377.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M696.68,248.95c1.6-1.4,3.4-2.8,5.4-4.4C700.28,246.15,698.48,247.55,696.68,248.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.48,894.95c-0.4-1-0.6-2-1-3C268.88,892.95,269.08,893.95,269.48,894.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.68,903.55c-0.6-0.8-1-1.8-1.4-2.6C272.88,901.75,273.28,902.75,273.68,903.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M706.28,542.55c-0.2-0.2-0.4-0.4-0.6-0.8C705.88,542.15,706.08,542.35,706.28,542.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M709.88,549.95c-0.4-1.4-1.2-2.6-1.8-3.8C708.68,547.55,709.28,548.75,709.88,549.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.48,694.15c-0.6,4.4-1.2,8.8-2,13.2c-1.2,11.6-2.4,22.8-3.8,33.8c-1.4,10.6-3.8,24.8-6.4,40.2 c-0.4,2.4-0.8,5.2-1.4,7.6c-1.4,10.4-2.8,20.6-4,29.8C280.28,770.75,285.48,729.75,289.48,694.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M695.28,532.95c-0.4-0.2-1-0.2-1.6-0.4c5.8,3.8,9.4,6.8,11.4,8.8C702.48,537.75,699.28,534.75,695.28,532.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.28,584.75c0,0.2,0,0.4,0,0.6c1.4,13.8,3,28.6,7.6,41.4c-1-3.2-2-6.4-2.4-10L716.28,584.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.88,389.95c-0.2,0-0.4-0.2-0.8-0.4c1.6,0.8,3.4,1.4,5.4,1.6L513.88,389.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M678.28,275.75c0.4-1,0.8-2,1.2-3C679.08,273.75,678.68,274.75,678.28,275.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M679.88,271.95c0.8-1.6,1.4-3.2,2.4-4.8C681.28,268.55,680.68,270.35,679.88,271.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M512.88,621.55c-24.6,14.4-45.6,45.4-49.6,74l-10.2,70.4c-7.8,55-48.2,115.2-96,143l-1.8,1 c-19.4,11.4-47.2,21.6-69,6.8c0.2,0.2,0.4,0.4,0.6,0.6c2.6,1.8,3.2,5.2,1.8,8c18.8,9,42.6,5.6,69.6-10.2l1.8-1 c49.4-28.8,91-90.6,98.8-147.6l10.2-70.4c3.8-26.8,23.4-56,46.6-69.4l77.8-45.4c-2-1.4-4-2.6-5.8-3.8L512.88,621.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M852.68,190.95c-0.4-0.2-0.8-0.2-1.2-0.4c20.2,12,24.6,52.2,31.2,112.6c4.8,44.2,10.6,99.2,24.8,163.4 c6,26.6-1.2,59.8-20.8,96.6c-19.2,35.8-45,64-74.8,81.2l-1.8,1c-24.6,14.4-47.4,18-64.2,10c-2.2-1-3.8-2.4-5.8-3.8 c0.8,0.6,1.6,1.4,2.4,2c2.4,1.6,3.2,4.8,2,7.4c17.8,7.8,41.8,5.2,68.6-10.4l1.8-1c30.8-18,57.4-46.8,77.2-83.8 c19.6-37,27.8-72.2,21.4-100.8c-32.8-147.6-21.4-247.2-53.8-276.4C858.28,191.15,855.28,192.15,852.68,190.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.88,284.55c-4.8,12.8-9.8,26.2-27,36.6C665.08,311.15,670.08,297.75,674.88,284.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M798.68,194.55c-25.2,8.4-56.4,24-91.6,46.6c-1.2,0.8-2,1.4-3.2,2.2c2.4-1.6,4.8-3.2,7.4-4.8 C748.48,216.95,776.88,202.75,798.68,194.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M536.08,386.35l7.6-4.4c-12.6,6.4-18.6,8.8-22,9.4C525.68,390.95,530.28,389.75,536.08,386.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M682.48,266.55c1-1.8,2-3.4,3.2-5.2C684.48,263.15,683.48,264.75,682.48,266.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.08,260.75c1.2-1.6,2.4-3.4,4-5C688.68,257.35,687.28,259.15,686.08,260.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M690.88,254.95c1.4-1.6,3-3.2,4.6-4.8C693.68,251.75,692.28,253.35,690.88,254.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.28,882.95c0,0.4,0.2,0.8,0.2,1c-0.2-0.6-0.2-1-0.4-1.6C266.28,882.55,266.28,882.75,266.28,882.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M493.68,363.95l11.4,6.4C502.68,366.95,499.08,364.35,493.68,363.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M283.88,741.15c1.4-10.8,2.6-22.2,3.8-33.8c-4.2,28.2-8.2,56.4-11.6,81.8c0.4-2.6,0.8-5.2,1.4-7.6 C279.88,765.95,282.28,751.75,283.88,741.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M800.28,187.35c-23,8-52.8,23-92,45.8c-2.4,1.4-4.4,2.8-6.4,4.2c-1.4,1-2.6,1.8-4,2.8c-1.2,1-2.4,1.8-3.6,2.8 c-1,0.8-2,1.6-3,2.6c-1.2,1-2.2,2-3.2,3.2c-0.8,0.8-1.6,1.6-2.2,2.4c-1,1.2-1.8,2.2-2.8,3.4c-0.6,0.8-1.2,1.6-1.8,2.2 c-0.8,1-1.4,2.2-2.2,3.2c-0.6,0.8-1.2,1.8-1.6,2.6c-0.4,0.8-0.8,1.6-1.4,2.4c-0.6,1.2-1.2,2.4-1.8,3.6c0,0.2-0.2,0.4-0.2,0.6 c-4.6,10.2-7,20-11.8,28.8c-0.2,0.4-0.4,0.8-0.6,1.2c0,0.2-0.2,0.2-0.2,0.4c-3.6,6.2-8.6,11.8-17,16.6c-11.8,7-74.8,46-106.8,62.2 l-5,3c-5,3-8.8,4-11.8,4.2c-0.2,0-0.6,0.2-0.6,0.2l-0.6-0.2c-1.4-0.2-2.8-0.4-3.8-1h-0.2l-14-8.2c0.6,1,1.2,1.8,1.8,2.8 c2.2,3.6,5.2,8.2,9.8,10.8c0.2,0.2,0.4,0.2,0.8,0.4l4.6,1.4c1,0.2,2,0.2,3.2,0c3.4-0.6,9.4-2.8,22-9.4l104.4-60.8 c17.2-10.4,22.2-23.6,27-36.6c0-0.2,0.2-0.4,0.2-0.6c1-2.8,2-5.6,3.2-8.4c0.4-1,0.8-2,1.2-3c0.2-0.4,0.4-0.6,0.4-1 c0.8-1.6,1.6-3.2,2.4-4.8c0-0.2,0.2-0.4,0.2-0.4c1-1.8,2-3.4,3.2-5.2c0.2-0.2,0.2-0.4,0.4-0.6c1.2-1.6,2.4-3.4,4-5 c0.2-0.2,0.6-0.6,0.8-0.8c1.4-1.6,3-3.2,4.6-4.8c0.4-0.4,0.8-0.8,1.2-1.2c1.6-1.4,3.4-2.8,5.4-4.4c0.6-0.4,1.4-1,2-1.4 c1-0.8,2-1.4,3.2-2.2c35.2-22.6,66.2-38.2,91.6-46.6c24.2-9,40.6-10.6,51.4-5c0.6,0.2,1,0.8,1.4,1c0.4,0.2,0.8,0.2,1.2,0.4 c2.6,1.2,5.4,0.2,7.2-2c-1.4-1.4-3-2.6-4.6-3.6C841.08,178.55,821.28,180.75,800.28,187.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M414.48,413.75c24-17.4,48-32.4,64.2-39.4c5.6-2.8,9.8-4,13-4.2l-8-4.6c-0.2,0-0.6,0.2-1,0.4 c-1.6,0.6-3.2,1.2-5,2c-2.4,1.2-5.2,2.6-8,4.2c-24,14-44.2,26.8-61.8,38.8c-27.2,19.8-53.6,42.4-68.6,60.2c-1,1.2-2.2,2.6-3.2,3.8 c1.2,0.8,2.2,2,2.6,3.4c0.4,1.4-0.2,2.8-0.8,4C354.28,459.75,378.48,438.15,414.48,413.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M329.28,495.75c0.4-0.6,0.8-1.2,1.2-1.8C330.08,494.55,329.68,495.15,329.28,495.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M316.88,521.95c3.2-8.8,7-17,11.6-25C323.68,504.55,319.68,512.55,316.88,521.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M679.48,259.75c-0.6,0.8-1,1.8-1.6,2.6C678.48,261.35,678.88,260.55,679.48,259.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M800.28,187.35c21-6.6,40.8-8.8,55-2C843.28,177.95,825.88,178.35,800.28,187.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M676.48,264.55c-0.6,1.2-1.2,2.4-1.8,3.6C675.28,266.95,675.88,265.75,676.48,264.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M694.48,242.95c-1,0.8-2,1.6-3,2.6C692.48,244.55,693.48,243.75,694.48,242.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M702.08,237.35c-1.4,1-2.6,1.8-4,2.8C699.28,239.15,700.68,238.15,702.08,237.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M683.28,254.15c-0.6,0.8-1.2,1.6-1.8,2.2C682.08,255.75,682.68,254.95,683.28,254.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M505.28,370.35l-11.4-6.4c-2.8-0.2-6,0.2-10,1.6l7.8,4.6c0.2,0,0.4,0,0.6,0c4.6,0,7.2,2.4,9.4,5.8l14,8.2h0.2 C511.28,381.55,508.88,375.35,505.28,370.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.08,250.95c0.6-0.8,1.4-1.6,2.2-2.4C687.48,249.35,686.88,250.15,686.08,250.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.08,298.75c0,0.2-0.2,0.2-0.2,0.4C661.88,298.95,661.88,298.95,662.08,298.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.48,268.75c-4.8,10.2-7,20-11.8,28.8C667.68,288.75,669.88,278.95,674.48,268.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M482.68,365.95c-1.6,0.6-3.2,1.2-5,2C479.48,367.15,481.08,366.55,482.68,365.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M520.28,385.35c0.2,0,0.4-0.2,0.6-0.2c-0.4,0-0.8,0-1.2,0L520.28,385.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M644.88,315.95l-106.8,62.2C569.88,361.75,633.08,322.95,644.88,315.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M339.08,471.15c15-17.8,41.4-40.4,68.6-60.2C377.08,432.15,355.08,451.35,339.08,471.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M293.88,653.15c2.6-25.6,5-47.8,7.8-67.6c-5.4,31.2-8.8,64.2-11.6,95.4c-0.8,9-1.6,17.8-2.4,26.4 c0.6-4.4,1.2-8.8,2-13.2C291.08,679.55,292.48,665.95,293.88,653.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M276.08,789.15c-3.2,18.4-6.4,38.2-8.4,55.4c1.6-8.8,3.2-17.4,4.6-25.6 C273.28,809.55,274.68,799.55,276.08,789.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.08,882.35c0,0.2,0,0.4,0,0.6C266.28,882.75,266.28,882.55,266.08,882.35L266.08,882.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M287.28,917.55c-0.2-0.2-0.4-0.4-0.6-0.6c-0.4-0.2-0.8-0.4-1-0.6c-4.8-3.4-8.6-7.8-11.8-12.8 c-0.6-0.8-1-1.8-1.4-2.6c-1-2-2-3.8-2.8-6c-0.4-1-0.6-2-1-3c-0.8-2.6-1.4-5.2-2-8c0-0.4-0.2-0.6-0.2-1c0-0.2,0-0.4,0-0.6 c-1.6-10.4-1.4-22.4,1.2-36.2c0.2-0.6,0.2-1,0.2-1.6c2-17.4,5.2-37,8.4-55.4c3.4-25.4,7.4-53.6,11.6-81.8 c0.8-8.6,1.6-17.4,2.4-26.4c3-31.2,6.2-64.2,11.6-95.4c3.6-24.4,8.2-45,15.2-63.6c2.8-9.4,6.8-17.4,11.6-25 c0.2-0.4,0.4-0.8,0.8-1.2c0.4-0.6,0.8-1.2,1.2-1.8c2.4-3.8,4.8-7.6,7.4-11.4c0.6-1.2,1-2.6,0.8-4c-0.4-1.4-1.4-2.4-2.6-3.4 c-0.6,0.8-1.2,1.6-1.8,2.6c-11.2,15.2-19.6,33.4-26,53.6l0,0c-0.4,2.2-12.8,80.8-25,163.4c-1.2,10.6-2.6,22-4,33.6 c-0.4,4-1,8.2-1.4,12c-0.4,2.8-0.8,5.8-1.2,9c-2.8,20.6-6,42.6-10.2,66.6c-4.4,34.8-7,60.6-6.2,67.4c0.2,0.8,0.2,1.4,0.4,2 c0.6,3,1.2,5.8,2.2,8.6c0.4,1,0.6,2,1,3c1,2.6,2,4.8,3.4,7.2c0.4,0.8,0.8,1.6,1.2,2.2c3.8,6,8.6,11.2,15,15.6 c1.8,1.2,3.8,2.4,5.6,3.4C290.48,922.75,289.88,919.35,287.28,917.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.88,486.75c-7,11-12.6,22.4-17.2,34.4c-1,3.2-2,6.4-2.6,10c6.4-20.2,15-38.4,26-53.6 c-0.8,1-1.6,2.2-2.2,3.2C330.48,482.75,329.08,484.75,327.88,486.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M277.68,740.35c0.6-4,1-8,1.4-12c-0.8,6.8-1.8,13.8-2.8,21C276.88,746.15,277.28,743.15,277.68,740.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.08,883.15L260.08,883.15c-0.8-6.6,1.8-32.4,6.2-67.2c-1.4,8.6-3,17.6-4.8,26.8 C259.48,859.55,258.68,873.95,260.08,883.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M283.08,694.55c12.2-82.6,24.6-161.2,25-163.4l0,0c-4.8,15-8.6,31-11.6,47.4 C291.48,610.15,288.48,647.75,283.08,694.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.88,486.75c1.4-2,2.6-4,4.2-6C330.48,482.75,329.08,484.75,327.88,486.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.48,885.55c0.6,3,1.2,6,2.2,8.6C261.88,891.35,261.08,888.55,260.48,885.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M268.48,906.55c3.6,5.8,8,10.8,13.4,14.8c0.4,0.4,1,0.6,1.4,0.8C277.08,917.75,272.08,912.55,268.48,906.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M296.48,578.55c3-16.6,6.8-32.6,11.6-47.4c0.6-3.6,1.6-6.8,2.6-10C304.28,538.35,299.88,557.15,296.48,578.55z "
}), React.createElement("path", {
  className: "st1",
  d: "M261.48,842.75c-0.2,0.8-0.2,1.6-0.4,2.4c-2.6,14.4-2.8,27-1,38C258.68,873.95,259.48,859.55,261.48,842.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M263.88,897.15c1,2.6,2,5,3.4,7.2C265.88,901.95,264.68,899.55,263.88,897.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M656.48,537.95l-56.6,33c1.8,1.2,3.8,2.4,6,3.8l53.8-31.4c6.4-3.8,12.6-5.8,18.2-6.6c-2.4-1.4-4.8-3-7.4-4.6 C665.88,533.55,661.28,535.15,656.48,537.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.88,653.55c-1-0.6-1.6-1.4-2.4-2c-7.6-5.6-13.4-13.8-16.6-24.6c-4.4-12.8-6-27.6-7.6-41.4 c0-0.2,0-0.4,0-0.6l-4.2-26.8c-0.4-2.8-1.2-5.4-2-7.8c-0.6-1.4-1.2-2.6-1.8-3.8c-0.6-1.2-1.2-2.6-1.8-3.6c-0.2-0.2-0.4-0.4-0.6-0.8 c-0.2-0.2-0.4-0.4-0.4-0.6c-2-2-5.8-5-11.4-8.8c-4.4-1.8-9.2-2.4-14.4-2c4.2,2.6,8,5,11.2,7.2c4.4,1.6,7.8,4.4,10.6,8.4 c0,0.2,0.4,0.2,0.4,0.4c1,1.4,1.8,3,2.4,4.8l0,0c3.8,9.2,5.2,22,6.6,35.8l5,31c0.8,5,2.2,9.6,3.8,13.8c0.8,2.2,1.8,4.2,2.8,6.2 c0.8,1.8,1.8,3.6,3,5.2c1.4,2.4,3.2,4.6,5,6.8c1.8,2,3.4,3.8,5.4,5.4c0.8,0.8,1.6,1.4,2.6,2c2.2,1.6,4.8,2.6,7.2,3.6 C746.08,658.35,745.28,655.15,742.88,653.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M588.08,577.75c1.8,1.2,3.8,2.4,5.8,3.8l6-3.6c-2-1.2-4-2.6-5.8-3.8L588.08,577.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.68,536.75c4.6-0.6,8.8-0.4,12.6,0.8c-3.2-2.2-6.8-4.6-11.2-7.2c-2.8,0.2-5.8,0.8-8.8,1.8 C672.88,533.75,675.48,535.35,677.68,536.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M701.28,546.35c0,0-0.2-0.2-0.4-0.4c1,1.6,2,3.2,2.8,5C703.08,549.35,702.28,547.75,701.28,546.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.88,570.95l-6,3.4c1.8,1.2,3.8,2.4,5.8,3.8l6-3.4C603.68,573.35,601.88,572.15,599.88,570.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.68,657.35c-1-0.6-1.8-1.4-2.6-2C735.88,655.95,736.88,656.75,737.68,657.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M719.08,631.75c0.8,2.2,1.8,4.2,2.8,6.2C720.68,635.95,719.88,633.75,719.08,631.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.28,586.95c-1.4-13.8-2.6-26.6-6.6-35.8c1,2.2,1.6,4.8,2,7.6L710.28,586.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M729.68,649.95c-1.8-2.2-3.6-4.4-5-6.8C726.08,645.55,727.88,647.75,729.68,649.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.28,562.55v-12c-1.6-4-3.2-8.2-4.4-12.6c-1,1.2-1.8,2.4-1.8,4l-0.2,20.6c0,2.2,1.2,4.2,3.2,5.4 c1,0.6,2,0.8,3.2,0.8c1,0,2.2-0.2,3.2-0.8l5.2-3c-1.2-1.6-2.2-3.4-3.4-5.2L564.28,562.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M630.28,524.15l-50.4,29.2c1,1.8,2,3.6,3.2,5.2l50-29.2c1.8-1.2,3.2-3.2,3.2-5.4v-12.2c-2-1.2-4-2.4-6-3.6 V524.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M619.88,502.55l-48.8,28.4c0.4,2.2,1,4.2,1.6,6.2l53.2-31C623.88,504.95,621.88,503.75,619.88,502.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M636.28,503.55c0-2.2-1-4.2-3-5.4c-2-1-4.4-1-6.4,0l-1.2,0.6c3.4,2,7,4,10.4,6v-1.2 C636.08,503.55,636.28,503.55,636.28,503.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M574.08,556.75l-4.8,2.8c1,1.8,2,3.6,3.4,5.2l5.2-3C576.48,560.15,575.28,558.55,574.08,556.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.28,541.95l2.8-1.6c-0.6-2-1.2-4-1.6-6.2l-4.2,2.4c-0.6,0.4-0.8,0.8-1.2,1.4c1.2,4.4,2.6,8.6,4.4,12.6 L564.28,541.95L564.28,541.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M572.68,536.95c-0.6-2-1.2-4-1.6-6.2l-5.6,3.2c0.4,2.2,1,4.2,1.6,6.2L572.68,536.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M574.08,556.75c1,1.8,2.4,3.4,3.6,5l5.4-3.2c-1.4-1.6-2.2-3.4-3.2-5.2L574.08,556.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.88,505.95l4.2-2.4v5c2,1.2,4,2.4,6,3.6v-7.2c-3.4-2-6.8-4-10.4-6l-6.2,3.6 C621.88,503.75,623.88,504.95,625.88,505.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M564.28,562.55l5-2.8c-1.8-3-3.6-5.8-5-9V562.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M623.88,514.35v6.4l-47.4,27.6c1,2,2.2,3.6,3.4,5.2l50.4-29.2v-15.8c-1.4-0.8-2.8-1.6-4.2-2.4l-53.2,31 c0.6,2,1.2,4,2,6L623.88,514.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M570.48,551.75v-2.2c-1.4-3-2.4-6.2-3.4-9.4l-2.8,1.6v8.6c1.4,3.2,3.2,6.2,5,9l4.8-2.8c-1-1.8-2-3.6-3-5.4 L570.48,551.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M576.68,548.15l-5.4,3.2c0.8,1.8,1.8,3.8,3,5.4l5.8-3.4C578.88,551.75,577.48,550.15,576.68,548.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M570.68,545.55l4-2.4c-0.8-2-1.4-4-2-6l-5.6,3.2c1,3.2,2,6.4,3.4,9.4L570.68,545.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M630.28,503.55l-4.2,2.4c1.4,0.8,2.8,1.6,4.2,2.4V503.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M489.68,508.15c-5.4-3-12.4-2.6-19.2,1.4l-14,8l0.2-16c0-7.8-3.2-14-8.4-17.2c-5.4-3-12.4-2.6-19,1.4l-13.6,8 c-12,7-21.4,23.2-21.4,37l-0.2,23.4l-20.2,11.8c-11.8,7-21.2,23.2-21.4,37v15.8c0,7.8,3,14,8.4,17.2c5.4,3,12.2,2.6,19.2-1.4 l13.8-8v16c0,7.8,3,14,8.4,17.2c2.2,1.4,4.8,2,7.8,2c3.6,0,7.4-1.2,11.2-3.4l13.8-8c12-7,21.4-23.2,21.4-37l0.2-23.4l20-11.8 c12-7,21.4-23.2,21.4-37l0.2-15.8C497.88,517.55,495.08,511.35,489.68,508.15z M491.68,541.15c0,11.6-8.4,25.8-18.2,31.6 l-23.2,13.6v26.8c-0.2,11.6-8.4,25.8-18.4,31.6l-13.6,8c-10,5.8-18.2,1-18.2-10.4l0.2-26.8l-23.2,13.4c-10,5.8-18.2,1.2-18.2-10.4 l0.2-15.8c0-11.6,8.2-25.8,18.2-31.8l23.2-13.4l0.2-26.8c0-11.6,8.4-25.8,18.2-31.6l13.8-8c10.2-5.8,18.2-1.2,18,10.4v26.8 l23.2-13.6c10-5.8,18.2-1.2,18,10.4v16H491.68z"
}), React.createElement("path", {
  className: "st1",
  d: "M473.68,514.75l-23.2,13.6v-26.8c0.2-11.6-8-16.4-18-10.4l-13.8,8c-9.8,5.8-18.2,20-18.2,31.6l-0.2,26.8 l-23.2,13.4c-10,5.8-18.2,20-18.2,31.8l-0.2,15.8c0,11.6,8.2,16.4,18.2,10.4l23.2-13.4l-0.2,26.8c0,11.6,8.2,16.2,18.2,10.4l13.6-8 c10.2-5.8,18.2-20,18.4-31.6v-26.8l23.2-13.6c10-5.8,18.2-20,18.2-31.6v-15.8C491.88,513.75,483.68,508.95,473.68,514.75z  M485.48,541.15c0,9.4-7.2,21.6-15.2,26.4l-23.2,13.4c-1.8,1.2-3,3.2-3,5.4l-0.2,26.8c0,9.4-7.2,21.8-15.4,26.4l-13.6,8 c-2.8,1.6-5.4,2-6.8,1.4c-1.4-0.8-2.2-3.2-2.2-6.4v-26.8c0-2.2-1-4.2-3-5.4c-1-0.6-2.2-0.8-3.2-0.8c-1,0-2.2,0.4-3.2,0.8l-23,13.6 c-2.8,1.6-5.2,2-6.6,1.4c-1.4-0.8-2.2-3.2-2.2-6.4v-15.8c0-9.4,7.2-21.6,15.2-26.4l23-13.6c2-1,3.2-3,3.2-5.2l0.2-26.8 c0-9.4,7.2-21.6,15.2-26.4l13.8-8c2.8-1.6,5.2-2,6.6-1.4c1.4,0.8,2.2,3.4,2.2,6.4l-0.2,26.8c0,2.2,1.2,4.2,3.2,5.4s4.2,1.2,6.2,0 l23.2-13.6c2.8-1.6,5.2-2,6.6-1.4c1.4,0.8,2.2,3.2,2.2,6.4L485.48,541.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.68,353.35c3.4,1.8,7.2,2.8,11.2,2.8c5.2,0,10.8-1.6,16.4-5c18.8-10.8,33.4-36.2,33.4-57.8 c0-11.8-4.2-20.6-11.8-25c-7.8-4.4-17.6-3.6-27.6,2c-18.8,10.8-33.4,36.2-33.4,57.8C776.68,340.15,780.88,348.95,788.68,353.35z  M813.28,275.95c16.6-9.6,30.2-1.8,30.2,17.6s-13.6,42.8-30.2,52.6c-16.8,9.6-30.4,1.8-30.4-17.6S796.48,285.55,813.28,275.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M813.28,345.95c16.6-9.8,30.2-33.2,30.2-52.6c0-19.4-13.6-27.2-30.2-17.6c-16.8,9.6-30.4,33.2-30.4,52.6 C782.88,347.75,796.48,355.55,813.28,345.95z M816.28,281.15c3.8-2.2,7.4-3.4,10.4-3.4c1.8,0,3.4,0.4,4.8,1.2c3.6,2.2,6,7.4,6,14.4 c0,17-12.6,38.6-27.4,47.2c-6,3.4-11.6,4.2-15.2,2c-3.6-2-5.8-7.4-5.8-14.2C788.88,311.35,801.48,289.75,816.28,281.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M728.28,453.15c3.6,2.2,9.2,1.4,15.2-2c14.8-8.6,27.2-30.2,27.2-47.2c0-7-2.2-12.2-5.8-14.4 c-1.4-0.8-3-1.2-4.8-1.2c-3.2,0-6.8,1.2-10.6,3.4c-14.8,8.6-27.2,30.2-27.2,47.2C722.48,445.75,724.68,450.95,728.28,453.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M722.08,463.75c3.4,1.8,7,2.8,11,2.8c5.2,0,10.8-1.6,16.6-5c18.8-10.8,33.6-36.2,33.6-57.8 c0-11.6-4.4-20.6-12-25c-7.8-4.4-17.6-3.8-27.6,2c-18.8,10.8-33.4,36.2-33.4,57.8C710.28,450.55,714.28,459.35,722.08,463.75z  M746.68,386.35c16.8-9.6,30.2-1.8,30.2,17.6c0,19.4-13.6,42.8-30.2,52.6c-16.8,9.6-30.4,1.8-30.4-17.6 C716.28,419.55,729.88,395.95,746.68,386.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.68,456.35c16.8-9.6,30.2-33.2,30.2-52.6c0-19.4-13.6-27.2-30.2-17.6c-16.8,9.6-30.4,33.2-30.4,52.6 C716.28,458.15,729.88,465.95,746.68,456.35z M749.68,391.55c3.8-2.2,7.4-3.4,10.6-3.4c1.8,0,3.2,0.4,4.8,1.2 c3.6,2.2,5.8,7.4,5.8,14.4c0,17-12.4,38.6-27.2,47.2c-6,3.4-11.6,4.2-15.2,2c-3.6-2-5.8-7.4-5.8-14.2 C722.48,421.75,734.88,400.15,749.68,391.55z"
}));

var SvgGamificationIcon = function SvgGamificationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGamificationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Gamification_Icon.f31106ae.svg";
export { ForwardRef as ReactComponent };